import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API } from "@/lib/api";

export default function PublicDemo() {
  const { slug } = useParams();
  const [info, setInfo] = useState(null);

  useEffect(() => {
    fetch(`${API}/public/demos/${encodeURIComponent(slug)}/info`).then((r) => r.json()).then((d) => {
      setInfo(d);
      if (d.available) document.title = d.title;
    }).catch(() => setInfo({ available: false }));
  }, [slug]);

  if (!info) return <div className="fixed inset-0 bg-white" />;
  if (!info.available) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-neutral-50 p-6 text-center" data-testid="public-demo-unavailable">
        <div>
          <p className="text-xl text-neutral-800">Demo non disponibile</p>
          <p className="mt-2 text-sm text-neutral-500">Il link potrebbe essere stato disattivato o non essere corretto.</p>
        </div>
      </div>
    );
  }
  return (
    <iframe
      title={info.title}
      src={`${API}/public/demos/${encodeURIComponent(slug)}`}
      sandbox="allow-scripts allow-forms allow-popups allow-modals allow-popups-to-escape-sandbox"
      className="fixed inset-0 w-full h-full border-0 bg-white"
      data-testid="public-demo-iframe"
    />
  );
}
